import React, { useCallback } from 'react'
import { TAG_CLICK_CONTEXT_MENU } from '../../../store/analytics/analytics.actionTypes'
import { ACTION } from '../../analytics/ClickTagsService'
import s from './ContextMenu.less'
import TagActionButton from '../../genericComponents/TagActionButton'
import { useContextMenu } from './ContextMenu'

const ContextMenuItem = ({ tagAction, label, clickAction }) => {
  const { point } = useContextMenu()

  const clickHandler = useCallback(() => {
    // do not stop propagation, so the menu can close
    clickAction(point)
  }, [point])

  return (
    <TagActionButton
      type={TAG_CLICK_CONTEXT_MENU}
      tagInfo={{
        [ACTION]: tagAction
      }}
      className={s.item}
      onClick={clickHandler}
    >
      {label}
    </TagActionButton>
  )
}

export default ContextMenuItem
